module.exports = require("./es6/index.js");



//////////////////
// WEBPACK FOOTER
// ./~/pizzip/utils/index.js
// module id = 498
// module chunks = 2